import {
  FeatureDefinition,
  FeatureDefinitionNext,
  FeatureDependenciesNext,
  FeatureDependencyNext,
  FeatureDependencyLegacy,
} from './types';

export const unifyFeaturesDefinitions = (features: FeatureDefinition[]): FeatureDefinitionNext[] => {
  return features.map((feature) => {
    if (feature.dependsOn) {
      return {
        ...feature,
        // prettier-ignore
        // @ts-ignore
        dependsOn: feature.dependsOn.map((dependency: FeatureDependencyNext | FeatureDependencyLegacy) => {
          if (typeof dependency === 'string') {
            return {
              name: dependency,
              required: true,
            };
          } else if (typeof dependency?.name === 'string') {
            return dependency;
          }

          return undefined;
        }).filter((dependency: FeatureDependencyNext | undefined) => !!dependency) as FeatureDependenciesNext,
      };
    }

    return feature as FeatureDefinitionNext;
  });
};
